var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { ThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Helmet } from 'react-helmet';
import { emptyCustomizations } from "./customization-types";
import { fetchCampaignFileAsJson, fetchBlobAsJson, THEME_FILE, LAYOUT_FILE, buildTheme, blobUrl, blobSubdomainUrl } from "./theme-helper";
import ErrorCard from "./error-card";
import LoadingIndicator from "./loading-indicator";
import { getClientContext } from "./general-helpers";
import { merge } from "lodash";
//===
// The context that holds the customizations
export var CustomizationsContext = React.createContext({
    version: process.env.REACT_APP_VERSION,
    isInitialized: false,
    environment: "",
    client: "",
    subdomain: "",
    isIframe: false,
    customizations: {},
    blobPaths: {},
    setCampaignName: function () { return ""; },
    blobUrl: function () { return ""; },
    blobSubdomainUrl: function () { return ""; },
    blobRootUrl: function () { return ""; },
    fetchFileAsJson: function () { return {}; },
    fetchCampaignFileAsJson: function () { return {}; }
});
//TODO: Temporary - would prefer to use mergeDeep in general-helpers, however
// that yields several non-unique key errors, so need to troubleshoot that.
var mergeLayouts = function (left, right) {
    var merged = merge(left, right);
    var withNewPlayer = __assign(__assign({}, merged), { player: __assign({}, merged.player) });
    return withNewPlayer;
};
//===
// Provider to wrap the app and offer customizations and theme to all children.
export var CustomizationsProvider = function (_a) {
    var _b, _c, _d;
    var children = _a.children;
    var _e = useState(false), isInitialized = _e[0], setIsInitialized = _e[1];
    //TODO: why are layout and customizations tracked separate when they're set to the same thing??
    // const [customizations, setCustomizations] = useState<ICustomizations>(emptyCustomizations);
    var _f = useState(null), themeJson = _f[0], setThemeJson = _f[1];
    var _g = useState(null), layout = _g[0], setLayout = _g[1];
    var _h = useState(null), theme = _h[0], setTheme = _h[1];
    var _j = useState(null), themeError = _j[0], setThemeError = _j[1];
    var _k = useState(null), theClientContext = _k[0], setClientContext = _k[1];
    //Step 1. Get the client context information
    useEffect(function () {
        function doEffect() {
            return __awaiter(this, void 0, void 0, function () {
                var theClientContext;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getClientContext()];
                        case 1:
                            theClientContext = _a.sent();
                            setClientContext(theClientContext);
                            console.log("Initializing @personicom/customizations (007) with Client Context:\n        \tClient: " + theClientContext.client + "\n        \tSubdomain: " + theClientContext.subdomain + "\n        \tEnvironment: " + theClientContext.environment);
                            return [2 /*return*/];
                    }
                });
            });
        }
        doEffect();
    }, []);
    //Step 2. Setup the Theme
    useEffect(function () {
        function doEffect(blobPaths, subdomain) {
            return __awaiter(this, void 0, void 0, function () {
                var rootTheme, subdomainTheme, mergedThemeJson, muiTheme;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchBlobAsJson(blobPaths.configPath, null, THEME_FILE)];
                        case 1:
                            rootTheme = _a.sent();
                            if (!rootTheme || rootTheme.isError) {
                                console.error("Failed to load root theme: ", rootTheme === null || rootTheme === void 0 ? void 0 : rootTheme.message);
                                setThemeError(rootTheme === null || rootTheme === void 0 ? void 0 : rootTheme.message);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, fetchBlobAsJson(blobPaths.configPath, subdomain, THEME_FILE)];
                        case 2:
                            subdomainTheme = _a.sent();
                            if (!subdomainTheme || subdomainTheme.isError) {
                                console.error("Failed to load subdomain theme: ", subdomainTheme === null || subdomainTheme === void 0 ? void 0 : subdomainTheme.message);
                                setThemeError(subdomainTheme === null || subdomainTheme === void 0 ? void 0 : subdomainTheme.message);
                                return [2 /*return*/];
                            }
                            mergedThemeJson = merge(rootTheme, subdomainTheme);
                            muiTheme = buildTheme(mergedThemeJson);
                            setTheme(muiTheme);
                            setThemeJson(mergedThemeJson);
                            return [2 /*return*/];
                    }
                });
            });
        }
        //A warning if we're hitting this multiple times
        if (!!theme)
            console.warn("WARNING: Re-initializing the Theme.");
        if (theClientContext)
            doEffect(theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths, theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.subdomain);
    }, [theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths, theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.subdomain]);
    //Step 3. Setup the Layout
    useEffect(function () {
        function doEffect(ctx) {
            return __awaiter(this, void 0, void 0, function () {
                var rootLayout, subdomainLayout, mergedLayoutJson;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchBlobAsJson(ctx.blobPaths.configPath, null, LAYOUT_FILE)];
                        case 1:
                            rootLayout = _a.sent();
                            if (!rootLayout || rootLayout.isError) {
                                console.error("Failed to load root layout: ", rootLayout === null || rootLayout === void 0 ? void 0 : rootLayout.message);
                                setThemeError(rootLayout === null || rootLayout === void 0 ? void 0 : rootLayout.message);
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, fetchBlobAsJson(ctx.blobPaths.configPath, ctx.subdomain, LAYOUT_FILE)];
                        case 2:
                            subdomainLayout = _a.sent();
                            if (!subdomainLayout || subdomainLayout.isError) {
                                console.error("Failed to load subdomain layout: ", subdomainLayout === null || subdomainLayout === void 0 ? void 0 : subdomainLayout.message);
                                setThemeError(subdomainLayout === null || subdomainLayout === void 0 ? void 0 : subdomainLayout.message);
                                return [2 /*return*/];
                            }
                            mergedLayoutJson = mergeLayouts(rootLayout, subdomainLayout);
                            // checkForMutation(mergedLayoutJson.player, customizations.player, "mergedLayoutJson");
                            setLayout(mergedLayoutJson);
                            return [2 /*return*/];
                    }
                });
            });
        }
        //A warning if we're hitting this multiple times
        if (!!layout)
            console.warn("WARNING: Re-initializing the Layout.");
        if (theClientContext)
            doEffect(theClientContext);
    }, [theClientContext]);
    //Step 4. Once both the layout and the theme are ready, the context is initialized.
    useEffect(function () {
        if (!!layout && !!theme && !isInitialized)
            setIsInitialized(true);
    }, [layout, theme]);
    //-- 
    // Uses a Campaign Name to search for a Campaign Layout File, and update the layout / customizations.
    var applyCampaign = function (campaignName) { return __awaiter(void 0, void 0, void 0, function () {
        var campaignLayout, layoutWithCampaign;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!theClientContext) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchCampaignFileAsJson(theClientContext.blobPaths.configPath, theClientContext.subdomain, campaignName, LAYOUT_FILE)];
                case 1:
                    campaignLayout = _a.sent();
                    if (campaignLayout && !campaignLayout.isError) {
                        console.info("Campaign layouts found, applying.");
                        layoutWithCampaign = mergeLayouts(layout !== null && layout !== void 0 ? layout : {}, campaignLayout);
                        // checkForMutation(layoutWithCampaign.player, customizations.player, "layoutWithCampaign");
                        setLayout(layoutWithCampaign);
                        // setCustomizations(layoutWithCampaign);          
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    if (!theClientContext || !theme) {
        if (themeError) {
            return (_jsx(Grid, __assign({ container: true, direction: "column", alignItems: "center", style: { marginTop: "10%" } }, { children: _jsx(ErrorCard, { message: "The system failed to load the theme for the current client and subdomain", details: themeError }, void 0) }), void 0));
        }
        else {
            return _jsx(LoadingIndicator, {}, void 0);
        }
    }
    else {
        var fontIndex_1 = 0;
        var externalLinkIndex_1 = 0;
        return (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [(_b = themeJson === null || themeJson === void 0 ? void 0 : themeJson.fonts) === null || _b === void 0 ? void 0 : _b.map(function (font) { return _jsx("style", __assign({ type: "text/css" }, { children: "@import url(" + font + ");" }), fontIndex_1++); }), (_c = themeJson === null || themeJson === void 0 ? void 0 : themeJson.externalLinks) === null || _c === void 0 ? void 0 : _c.map(function (theLink) { return _jsx("link", { rel: theLink.rel, href: theLink.href }, externalLinkIndex_1++); })] }, void 0), _jsx(CustomizationsContext.Provider, __assign({ value: {
                        version: theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.version,
                        isInitialized: isInitialized,
                        customizations: (_d = layout) !== null && _d !== void 0 ? _d : emptyCustomizations,
                        isIframe: theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.isIframe,
                        environment: theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.environment,
                        client: theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.client,
                        subdomain: theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.subdomain,
                        blobPaths: theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths,
                        setCampaignName: applyCampaign,
                        blobUrl: function (filename) { return blobUrl(theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths.configPath, theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.subdomain, filename); },
                        blobSubdomainUrl: function (filename) { return blobSubdomainUrl(theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths.configPath, theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.subdomain, filename, theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.environment); },
                        blobRootUrl: function (filename) { return blobUrl(theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths.configPath, "", filename); },
                        fetchFileAsJson: function (filename) { return fetchBlobAsJson(theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths.configPath, theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.subdomain, filename); },
                        fetchCampaignFileAsJson: function (campaignName, filename) { return fetchCampaignFileAsJson(theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.blobPaths.configPath, theClientContext === null || theClientContext === void 0 ? void 0 : theClientContext.subdomain, campaignName, filename); },
                    } }, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: children }), void 0) }), void 0)] }, void 0));
    }
};
